
import Header from "@/components/Header";
import PageHero from '@/components/PageHero';
import { Briefcase, Users, BarChart2, Zap, Mail, Linkedin } from "lucide-react";
import { LinkButton } from '@/components/Button';

const benefits = [
  {
    icon: <Users className="w-6 h-6 text-[hsl(var(--bronze-gold))]" />,
    title: "Collaborative Culture",
    description: "Work with a team of passionate professionals in a supportive environment."
  },
  {
    icon: <Zap className="w-6 h-6 text-[hsl(var(--bronze-gold))]" />,
    title: "Growth Opportunities",
    description: "Develop your skills and advance your career in the fintech and investment space."
  },
  {
    icon: <BarChart2 className="w-6 h-6 text-[hsl(var(--bronze-gold))]" />,
    title: "Impactful Work",
    description: "Contribute to transforming how South Africans access alternative investments."
  }
];

const Careers = () => {
  return (
    <div className="min-h-screen bg-white">
      <PageHero 
        title="Build the Future of Alternative Investments"
        subtitle="Join ALTA-X in our mission to democratize access to institutional-quality alternative investments in South Africa."
        backgroundImage="https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg"
      />

      {/* No Open Positions */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[hsl(var(--bronze-gold))]/10 mb-8">
            <Briefcase className="w-10 h-10 text-[hsl(var(--bronze-gold))]" />
          </div>
          <h2 className="text-3xl font-bold text-[hsl(var(--navy))] mb-6">No Open Positions at This Time</h2>
          <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
            We're not currently hiring, but we're always interested in connecting with talented individuals who are passionate about fintech and alternative investments.
          </p>
          
          <div className="bg-gray-50 rounded-xl p-8 max-w-2xl mx-auto mt-12">
            <h3 className="text-xl font-semibold text-[hsl(var(--navy))] mb-4">Join Our Talent Network</h3>
            <p className="text-gray-600 mb-6">
              Send us your resume and tell us why you'd be a great fit for our team. We'll keep your information on file for future opportunities.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <a 
                href="mailto:careers@altax.co.za?subject=Future%20Opportunity%20at%20ALTA-X" 
                className="inline-flex items-center justify-center rounded-full px-6 py-3 font-medium text-base bg-gray-800 text-white hover:bg-gray-700"
              >
                <Mail className="w-5 h-5 mr-2" />
                Send Us Your Resume
              </a>
              <a 
                href="https://www.linkedin.com/company/alta-x" 
                className="inline-flex items-center justify-center rounded-full px-6 py-3 font-medium text-base border-2 border-gray-800 text-gray-800 hover:bg-gray-100"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Linkedin className="w-5 h-5 mr-2" />
                Follow on LinkedIn
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Why Join Us */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-[hsl(var(--navy))] mb-4">Why Join ALTA-X?</h2>
            <p className="text-gray-600 max-w-3xl mx-auto">
              We're building a team of forward-thinkers who are passionate about innovation in finance.
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {benefits.map((benefit, index) => (
              <div key={index} className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow">
                <div className="w-12 h-12 rounded-full bg-[hsl(var(--bronze-gold))]/10 flex items-center justify-center mb-4">
                  {benefit.icon}
                </div>
                <h3 className="text-xl font-semibold text-[hsl(var(--navy))] mb-2">{benefit.title}</h3>
                <p className="text-gray-600">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Careers;
